import React from 'react'

export const VisibleXlOnly = ({ children }) => (
  <div className="show-xl-only">{children}</div>
)

export const VisibleLgBelow = ({ children }) => (
  <div className="hide-xl-only">{children}</div>
)
